import content from "./content";

export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-[#f8fbff] px-5 py-10 text-slate-700 md:px-8 md:py-16">
      <article className="mx-auto max-w-4xl rounded-3xl border border-blue-100 bg-white p-6 shadow-sm md:p-12">
        <div className="space-y-4">
          {content.map((block, index) => block.type === "title" ? <h1 key={index} className="mb-8 text-2xl font-black leading-tight text-[#102f66] md:text-4xl">{block.text}</h1> : block.type === "heading" ? <h2 key={index} className="mt-9 border-b border-blue-100 pb-3 text-lg font-black text-[#102f66] md:text-xl">{block.text}</h2> : <p key={index} className="whitespace-pre-line text-sm leading-7 text-slate-600 md:text-[15px]">{block.text}</p>)}
        </div>
      </article>
    </main>
  );
}
